import { Container, Spin, Text } from "./styles";

export const Loader_SC = ({ loading, noBack = false }) => {
  return (
    <>
      {loading && (
        <Container loading={loading} noBack={noBack}>
          <Spin>
            <Text>cargando... </Text>
          </Spin>
        </Container>
      )}
    </>
  );
};
